import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var httpOptions = {
    headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*'
    })
};
// <script type="text/javascript" src="https://www.oil-price.net/widgets/brent_crude_price_large/gen.php?lang=en"> </script>
// <noscript> To get the BRENT <a href="http://www.oil-price.net/dashboard.php?lang=en#brent_crude_price_large">oil price</a>, please enable Javascript.</noscript>	
var TestSerService = /** @class */ (function () {
    function TestSerService(_http) {
        this._http = _http;
    }
    TestSerService.prototype.dailyForecast = function () {
        return this._http.get("http://www.oil-price.net/dashboard.php?lang=en#brent_crude_price_large", {
            responseType: "json",
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*'
            })
        })
            .map(function (result) {
            result.json();
        });
    };
    TestSerService.ngInjectableDef = i0.defineInjectable({ factory: function TestSerService_Factory() { return new TestSerService(i0.inject(i1.HttpClient)); }, token: TestSerService, providedIn: "root" });
    return TestSerService;
}());
export { TestSerService };
